import { useState, useEffect, useCallback } from 'react';
import { collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useSchool } from '../contexts/SchoolContext';
import { useAuth } from '../features/auth/hooks/useAuth';

export function useEmailInbox() {
  const { schoolId } = useSchool();
  const { user } = useAuth();
  const [emails, setEmails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!schoolId || !user?.uid) {
      setEmails([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    const colRef = collection(db, 'schools', schoolId, 'communications');
    const q = query(
      colRef,
      where('teacherId', '==', user.uid),
      where('channel', '==', 'email'),
      orderBy('receivedAt', 'desc'),
      limit(50)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const docs = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        setEmails(docs);
        setUnreadCount(docs.filter(d => !d.isRead).length);
        setIsLoading(false);
      },
      (err) => {
        setError(err.message);
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [schoolId, user?.uid]);

  return { emails, isLoading, unreadCount, error };
}

export default useEmailInbox;
